import React from 'react'
import _cx from 'classnames/bind'
import { noop } from 'lodash'
import { Text, utils as coreUtils } from '@adc/ui-core'
import cls from '../../../scss/base.scss'
import { OnlineAuctionSegmentBid } from '@adc/sdk/types'
import TraditionalOfferActionFooter from '../traditionalOfferActionFooter'

const cx = _cx.bind(cls)

const BID_PENDING = 'Declining the offer now...'

const BID_AMOUNT_CHANGED =
  'The bid changed while you were accepting, do you want to accept at the new price?'

const ACKNOWLEDGE_TEXT =
  'I acknowledge that I have reviewed the buyer’s offer, terms, contingencies, and any other relevant information before declining this offer.'

interface DeclineBidContentProps {
  isLoading: boolean
  bid: OnlineAuctionSegmentBid
  disclaimerAcknowledged: boolean
  setDisclaimerAcknowledged: (checked: boolean) => void
}

export const DeclineBidContent = ({
  isLoading,
  bid,
  disclaimerAcknowledged = false,
  setDisclaimerAcknowledged = noop,
}: DeclineBidContentProps) => {
  const { afterAdjustments } =
    coreUtils.traditionalOffer.getOfferTermsCalculations(bid)

  return (
    <div>
      <Text className={cx('u-mb-2')} size='tiny' color='grayDark'>
        You are about to decline an offer on your listing. Ensure you have
        carefully reviewed the buyer’s offer, including the terms,
        contingencies, and any other relevant details, as this action cannot be
        undone. Please note that the buyer may submit a new offer unless another
        offer has been accepted or the Highest and Best round has started.
      </Text>
      <TraditionalOfferActionFooter
        disclaimerAcknowledged={disclaimerAcknowledged}
        setDisclaimerAcknowledged={setDisclaimerAcknowledged}
        isLoading={isLoading}
        bidAmount={afterAdjustments}
        loadingText={BID_PENDING}
        acknowledgeText={ACKNOWLEDGE_TEXT}
        alertText={BID_AMOUNT_CHANGED}
      />
    </div>
  )
}

export default DeclineBidContent
